import { createContext } from 'react'

import { PulseSurveysContextValueType } from './PulseSurveysContext.types'

export const PulseSurveysContext = createContext<PulseSurveysContextValueType | undefined>(undefined)
